import React, { memo } from 'react';

const TrialIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 970 1024">
        <path
            fill="none"
            stroke={color}
            strokeLinejoin="miter"
            strokeLinecap="butt"
            strokeMiterlimit="4"
            strokeWidth="53.8947"
            d="M943.158 512c0 253.005-205.101 458.105-458.105 458.105s-458.105-205.101-458.105-458.105c0-253.005 205.101-458.105 458.105-458.105s458.105 205.101 458.105 458.105z"
        ></path>
        <path
            fill={color}
            d="M291.033 512.008l34.196 34.194 135.572-135.327v295.152h48.505v-295.152l135.329 135.57 34.439-34.436-194.020-194.021-194.021 194.021z"
        ></path>
    </svg>
);

export default memo(TrialIcon);
